import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../firebaseConfig";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { Link } from "react-router-dom";

const Register = () => {
  const [username, setUsername] = useState("");
  const [company, setCompany] = useState("");
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [zone] = useState("DK1");
  const [error, setError] = useState("");
  const [acceptedPolicy, setAcceptedPolicy] = useState(false);
  const navigate = useNavigate();

  const genPwd = () => crypto.randomUUID().replace(/-/g, "") + "Aa1!";

  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");

    if (!acceptedPolicy) {
      setError("You must accept the Privacy Policy to register.");
      return;
    }

    try {
      const randomPassword = genPwd();
      const userCredential = await createUserWithEmailAndPassword(auth, email, randomPassword);
      await setDoc(doc(db, "registrations", userCredential.user.uid), {
        username,
        company,
        name,
        lastName,
        email,
        zone,
        createdAt: serverTimestamp()
      });
      navigate("/thank-you");
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className='background'>
      <div className='line-overlay'></div>
      <div className='left-content'>
        <img src="/neonlogo.png" className="img-container" alt="Price level"/>
        
        <div className="register-form-container zoom-in-transition">
          <h2>REGISTER</h2>
          {error && <p className="error-message">{error}</p>}
          
          <form onSubmit={handleRegister}>
            <div className="form-group form-group--row">
              <input
                type="text"
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />

            </div>
            <div className="form-inline">
              <small style={{ color: "#eef6ff", paddingBottom: 15, fontSize: 12}}>* Required to put in username before game starts</small>
            </div>
            <div className="form-group">
              <input
                type="text"
                placeholder="Company"
                value={company}
                onChange={(e) => setCompany(e.target.value)}
                required
              />
            </div>

            <div className="form-group form-group--row">
              <input
                type="text"
                placeholder="First Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
              <input
                type="text"
                placeholder="Last Name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="form-inline">
              <input
                type="checkbox"
                id="privacy-policy"
                checked={acceptedPolicy}
                onChange={(e) => setAcceptedPolicy(e.target.checked)}
              />
              <label htmlFor="privacy-policy">
                I accept the <Link to="/privacy-policy" target="_blank">Privacy Policy</Link>
              </label>
            </div>
            
            <button type="submit" className="register-submit-btn" disabled={!acceptedPolicy}>
              REGISTER
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Register;
